import React from "react";
import { Box } from "@mui/material";
import SectionTitle from "../../../../../SectionTitle";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import messages from "../../../../../../assets/locale/messages";
import { getLocalizedPersonName } from "../../../../../../utils/companyPortal/eventApi";
import { clx } from "../../../../../../utils/Helpers";

import "../../../_EventDetailFields.scss";

const PANEL_TITLE_COLOR =
  "var(--color-sidebar-gradient-start, rgba(49, 35, 125, 1))";

const SupervisorInfo = ({ zone }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events.viewEvents;

  const supervisorName = getLocalizedPersonName(zone?.supervisor, lang);
  const isAssigned =
    zone?.supervisor?.status === "assigned" ||
    zone?.supervisor_status === "assigned" ||
    !!supervisorName;

  return (
    <Box>
      <SectionTitle
        icon={<GppGoodOutlinedIcon />}
        label={t.supervisorInfo}
        classNames={{ label: "event-detail-panel-title" }}
        IconSx={{ color: PANEL_TITLE_COLOR }}
      />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <div className="event-detail-field">
          <span className="event-detail-label">{t.currentStatus}</span>
          <span
            className={clx(
              "event-detail-status-badge",
              isAssigned
                ? "event-detail-status-badge--assigned"
                : "event-detail-status-badge--unassigned",
            )}
          >
            {isAssigned ? t.assigned : t.unassigned}
          </span>
        </div>

        <div className="event-detail-field">
          <span className="event-detail-label">{t.supervisorName}</span>
          <span
            className={clx(
              "event-detail-value",
              !supervisorName && "event-detail-value--muted",
            )}
          >
            {supervisorName || t.notAssignedYet}
          </span>
        </div>
      </Box>
    </Box>
  );
};

SupervisorInfo.propTypes = {
  zone: PropTypes.object.isRequired,
};

export default SupervisorInfo;
